var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2079_12698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6.66622L9.33333 3.99955M1.66664 14.3329L3.92289 14.0822C4.19855 14.0516 4.33638 14.0362 4.46521 13.9945C4.5795 13.9575 4.68827 13.9053 4.78857 13.8391C4.90161 13.7646 4.99967 13.6665 5.19579 13.4704L14 4.66622C14.7364 3.92984 14.7364 2.73593 14 1.99955C13.2636 1.26317 12.0697 1.26317 11.3333 1.99955L2.52913 10.8037C2.33301 10.9999 2.23494 11.0979 2.1604 11.211C2.09426 11.3113 2.04198 11.42 2.00498 11.5343C1.96328 11.6632 1.94796 11.801 1.91733 12.0766L1.66664 14.3329Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2079_12698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e0d1a294f9bb93b58821ad20db3f2361.svg";
export { ForwardRef as ReactComponent };